export const COLUMNS = {
    ACCOUNT_NAME: 'name',
    ACCOUNT_STATUS: 'status',
    LICENSE_TYPE: 'licenseType',
    LICENSED_USERS: 'licensedUsers',
    LICENSE_ENDS: 'licenseEndDate',
    PRIMARY_ACCOUNT_TEAM_MEMBER: 'primaryAccountTeamMember',
};

export const HEADERS = {
    [COLUMNS.ACCOUNT_NAME]: 'Account Name',
    [COLUMNS.ACCOUNT_STATUS]: 'Account Status',
    [COLUMNS.LICENSE_TYPE]: 'License Type',
    [COLUMNS.LICENSED_USERS]: 'Licensed Enabled Users',
    [COLUMNS.LICENSE_ENDS]: 'License Ends',
    [COLUMNS.PRIMARY_ACCOUNT_TEAM_MEMBER]: 'Primary Account Team Member',
};

export const COLUMNS_DATA = [
    {
        columnId: COLUMNS.ACCOUNT_NAME,
        fixed: true,
        defaultWidth: 400,
        minWidth: 400,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.ACCOUNT_STATUS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.LICENSE_TYPE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.LICENSED_USERS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 170,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.LICENSE_ENDS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
    },
    {
        columnId: COLUMNS.PRIMARY_ACCOUNT_TEAM_MEMBER,
        fixed: false,
        defaultWidth: 280,
        minWidth: 280,
        maxWidth: 500,
    },
];

export const SELECTION_KEY = 'assigned-accounts';
export const PLACE = 'Assigned Accounts';
